export default __webpack_public_path__ + "static/media/2070.31ebd07d.png";